import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ContractorSpotlight = () => {
  const contractors = [
  {
    id: 1,
    name: "Mike Rodriguez",
    company: "Rodriguez Roofing Solutions",
    location: "Austin, TX",
    experience: "8 years",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18b6f5f35-1763296280847.png",
    avatarAlt: "Professional headshot of Hispanic man with short black hair wearing navy blue shirt",
    monthlyJobs: 22,
    avgRating: 4.9,
    totalEarnings: "$180K",
    specialties: ["Asphalt Shingles", "Metal Roofing", "Storm Damage"],
    testimonial: "OpenbooQ transformed my business. The steady work flow and transparent pricing mean I can focus on what I do best - quality roofing. My income increased 40% in the first year.",
    joinedDate: "January 2023",
    certifications: ["GAF Master Elite", "OSHA 30"]
  },
  {
    id: 2,
    name: "Sarah Chen",
    company: "Precision Roofing Co.",
    location: "Denver, CO",
    experience: "12 years",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10d60e496-1763295319842.png",
    avatarAlt: "Professional headshot of Asian woman with long dark hair wearing white blazer",
    monthlyJobs: 18,
    avgRating: 5.0,
    totalEarnings: "$165K",
    specialties: ["Tile Roofing", "Solar Integration", "Green Roofing"],
    testimonial: "The platform\'s digital tools and customer management system have streamlined my entire operation. I spend less time on paperwork and more time growing my business.",
    joinedDate: "March 2023",
    certifications: ["NRCA Member", "Tesla Solar Certified", "LEED AP"]
  },
  {
    id: 3,
    name: "David Thompson",
    company: "Thompson & Sons Roofing",
    location: "Phoenix, AZ",
    experience: "15 years",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_102b4eeba-1763291930569.png",
    avatarAlt: "Professional headshot of Caucasian man with brown hair and beard wearing dark suit",
    monthlyJobs: 25,
    avgRating: 4.8,
    totalEarnings: "$195K",
    specialties: ["Commercial Roofing", "Flat Roofs", "Maintenance"],
    testimonial: "Three generations of our family have been in roofing. OpenbooQ helps us maintain our traditional values while embracing modern technology and business practices.",
    joinedDate: "August 2022",
    certifications: ["NRCA Certified", "Firestone Master Contractor", "IB Certified"]
  }];


  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center space-y-6 mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-primary/10 rounded-full">
            <Icon name="Award" size={16} className="text-primary mr-2" />
            <span className="text-sm font-medium text-primary">Success Stories</span>
          </div>
          
          <h2 className="text-3xl lg:text-4xl font-jakarta font-bold text-text-primary">
            Meet Our Top Performing Contractors
          </h2>
          
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Real contractors, real results. See how our partners are growing their businesses 
            and achieving financial success with OpenbooQ.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {contractors?.map((contractor) =>
          <div
            key={contractor?.id}
            className="bg-white border border-border rounded-2xl p-8 hover:shadow-trust transition-all duration-300 hover:-translate-y-1">

              <div className="space-y-6">
                {/* Header */}
                <div className="flex items-start space-x-4">
                  <div className="relative">
                    <Image
                    src={contractor?.avatar}
                    alt={contractor?.avatarAlt}
                    className="w-16 h-16 rounded-full object-cover" />

                    <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full flex items-center justify-center">
                      <Icon name="Check" size={12} className="text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-jakarta font-bold text-text-primary">{contractor?.name}</h3>
                    <p className="text-sm text-text-secondary">{contractor?.company}</p>
                    <div className="flex items-center space-x-4 mt-2">
                      <div className="flex items-center space-x-1">
                        <Icon name="MapPin" size={12} className="text-text-secondary" />
                        <span className="text-xs text-text-secondary">{contractor?.location}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={12} className="text-text-secondary" />
                        <span className="text-xs text-text-secondary">{contractor?.experience}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-4">
                  <div className="text-center p-3 bg-surface rounded-lg">
                    <div className="text-lg font-jakarta font-bold text-primary">{contractor?.monthlyJobs}</div>
                    <div className="text-xs text-text-secondary">Jobs/Month</div>
                  </div>
                  <div className="text-center p-3 bg-surface rounded-lg">
                    <div className="text-lg font-jakarta font-bold text-primary">{contractor?.avgRating}</div>
                    <div className="text-xs text-text-secondary">Avg Rating</div>
                  </div>
                  <div className="text-center p-3 bg-surface rounded-lg">
                    <div className="text-lg font-jakarta font-bold text-primary">{contractor?.totalEarnings}</div>
                    <div className="text-xs text-text-secondary">Annual</div>
                  </div>
                </div>

                {/* Testimonial */}
                <div className="space-y-4">
                  <div className="flex items-center space-x-1">
                    {[...Array(5)]?.map((_, i) =>
                  <Icon
                    key={i}
                    name="Star"
                    size={16}
                    className="text-warning fill-current" />

                  )}
                  </div>
                  <blockquote className="text-sm text-text-secondary italic leading-relaxed">
                    "{contractor?.testimonial}"
                  </blockquote>
                </div>

                {/* Specialties */}
                <div className="space-y-3">
                  <h4 className="text-sm font-jakarta font-semibold text-text-primary">Specialties:</h4>
                  <div className="flex flex-wrap gap-2">
                    {contractor?.specialties?.map((specialty, index) =>
                  <span
                    key={index}
                    className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">

                        {specialty}
                      </span>
                  )}
                  </div>
                </div>

                {/* Certifications */}
                <div className="space-y-3">
                  <h4 className="text-sm font-jakarta font-semibold text-text-primary">Certifications:</h4>
                  <div className="space-y-2">
                    {contractor?.certifications?.map((cert, index) =>
                  <div key={index} className="flex items-center space-x-2">
                        <Icon name="Shield" size={12} className="text-success" />
                        <span className="text-xs text-text-secondary">{cert}</span>
                      </div>
                  )}
                  </div>
                </div>

                {/* Footer */}
                <div className="pt-4 border-t border-border">
                  <div className="flex items-center justify-between text-xs text-text-secondary">
                    <span>Joined {contractor?.joinedDate}</span>
                    <div className="flex items-center space-x-1">
                      <Icon name="TrendingUp" size={12} className="text-success" />
                      <span className="text-success">Top Performer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-2xl p-8 lg:p-12">
            <h3 className="text-2xl font-jakarta font-bold text-text-primary mb-4">
              Ready to Join Our Success Stories?
            </h3>
            <p className="text-text-secondary mb-6 max-w-2xl mx-auto">
              These contractors started just like you. With dedication, quality work, and our platform support, 
              you can achieve similar success and growth.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="inline-flex items-center px-6 py-3 bg-primary text-white font-medium rounded-lg hover:bg-primary/90 transition-colors duration-200">
                <Icon name="FileText" size={16} className="mr-2" />
                Start Your Application
              </button>
              <button className="inline-flex items-center px-6 py-3 border border-border text-text-primary font-medium rounded-lg hover:bg-surface transition-colors duration-200">
                <Icon name="MessageCircle" size={16} className="mr-2" />
                Talk to a Contractor
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ContractorSpotlight;